import React, {ReactElement} from 'react';
import {Link} from 'react-router-dom';
import {Typography} from '@customink/pigment-react';
import OrderConfirmNextStepsSkeleton from './OrderConfirmNextStepsSkeleton';
import {useStoreSlug} from '../../hooks';
import './index.scss';

type OrderConfirmNextStepsProps = {
  organizerEmail: string;
  placeholder?: boolean;
};

const OrderConfirmNextSteps: React.FC<OrderConfirmNextStepsProps> = ({
  organizerEmail,
  placeholder
}: OrderConfirmNextStepsProps): ReactElement => {
  const urlSlug = useStoreSlug();
  return placeholder ? (
    <OrderConfirmNextStepsSkeleton />
  ) : (
    <div className="next-steps">
      <Typography variant="h4" className="next-steps-header">
        What Happens Next?
      </Typography>
      <Typography variant="bodyShort2" className="next-steps-title">
        Check Your Email
      </Typography>
      <Typography variant="bodyShort2" className="next-steps-section">
        Check your email for your order confirmation and receipt. If you
        don&apos;t see an email soon, check your spam folder for messages from{' '}
        <a href="mailto:service@customink.com">service@customink.com</a>.
      </Typography>
      <Typography variant="bodyShort2" className="next-steps-title">
        Artist Review
      </Typography>
      <Typography variant="bodyShort2" className="next-steps-section">
        Custom Ink&apos;s artists will carefully review your design. If there
        are questions or suggestions, we will contact you at{' '}
        <a href={`mailto:${organizerEmail}`}>{organizerEmail}</a> before we
        print.
      </Typography>
      <Typography variant="bodyShort2" className="next-steps-title">
        Review Your Order
      </Typography>
      <Typography variant="bodyShort2" className="next-steps-section">
        Return to <Link to={`/${urlSlug}/manage/dashboard`}>Dashboard</Link> to
        review details of your order, including the total amount collected as
        well as individual participant purchase details.
      </Typography>
    </div>
  );
};

OrderConfirmNextSteps.defaultProps = {
  placeholder: false
};

export default OrderConfirmNextSteps;
